/**
 * 
 */
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import Config from "../../utils/Config";
import Tools from "../../utils/Tools";
import { fetchGetUserDataForUser } from "./Api/UserApi";
import { ColorEnum } from "@/utils/SuperEnum";
import { MessageGroupTypeEnum } from "@/utils/MessageNoticeEnum";
export default class SignalRService {
    private TAG: string = "SignalRService";
    /**
     * 当前登录的用户User
     */
    private user: DB.User | undefined = undefined;
    private _connection: HubConnection | null = null;
    private static _instance: SignalRService;
    public static get Instance(): SignalRService {
        if (this._instance == null)
            this._instance = new SignalRService();
        return this._instance;
    }

    constructor() {
        this.init();
    }
    private init() {
        let builder = new HubConnectionBuilder();
        builder.withUrl(Config.SignalRHost);
        builder.withAutomaticReconnect();
        this._connection = builder.build();

        this._connection.onreconnected(async (connectionId?: string) => {
            Tools.ShowLog(this.TAG, "SignalR服务重连", ColorEnum.Error);
            //让连接绑定到用户
            await SignalRService.Instance.JoinGroupAsync(MessageGroupTypeEnum.SYSTEM); //加入到系统变更组
        });

        this._connection.onclose((err) => {
            this.user = undefined;
            Tools.ShowLog(this.TAG, "关闭了SignalR服务", ColorEnum.Error);
        });
    }
    /**
     * 监听一次
     * @param key 
     * @param callFun 
     */
    public AddEventOnce(key: string, callFun: (...args: any[]) => void) {
        this.RemoveEvent(key);
        this.AddEvent(key, callFun);
    }

    /**
     * 
     * @param key 
     * @param callFun 
     */
    public AddEvent(key: string, callFun: (...args: any[]) => void) {
        if (this._connection) {
            Tools.ShowLog(this.TAG, `添加事件:${key}`, ColorEnum.Info);
            this._connection.on(key, callFun);
        }
        else {
            Tools.ShowLog(this.TAG, "未初始化SignalR服务", ColorEnum.Error);
        }
    }

    /**
     * 删除事件
     * @param key 
     */
    public RemoveEvent(key: string) {
        Tools.ShowLog(this.TAG, `删除事件:${key}`, ColorEnum.Error);
        this._connection?.off(key);
    }

    /**
     * 加入到组
     * @param groupName 
     */
    public async JoinGroupAsync(groupName: string) {
        Tools.ShowLog(this.TAG, `加入群组:${groupName}`, ColorEnum.Success);
        return await this._connection?.invoke<boolean>("JoinGroup", groupName);
    }

    /**
     * 离开组
     * @param groupName 
     */
    public async LeaveGroupAsync(groupName: string) {
        Tools.ShowLog(this.TAG, `离开群组:${groupName}`, ColorEnum.Error);
        return await this._connection?.invoke<boolean>("LeaveGroup", groupName);
    }

    /**
     * 
     * @param key 
     * @param anys 
     * @returns 
     */
    public async InvokeMessage<T>(key: string, ...anys: any[]) {
        return await this._connection?.invoke<T>(key, ...anys);
    }

    /**
     * 
     * @param key 
     * @param anys 
     * @returns 
     */
    public async SendMessageAsync(key: string, ...anys: any[]) {
        return await this._connection?.send(key, ...anys);
    }

    /**
     * 启动连接
     * @returns 
     */
    public async StartAsync() {
        return this._connection?.start();
    }
}